// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"59":"7ece4b2f","173":"819a15a3","251":"fa2360a2","754":"bc01fbab","813":"08720cb2","849":"2611a763","977":"08756d76"}[chunkId] + ".chunk.js";
};